// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-in .dropdown-toggle {\r\n  display: flex !important;\r\n  justify-content: center;\r\n  flex-direction: row;\r\n  align-items: center;\n}\r\n", ""]);
// Exports
module.exports = exports;
